import type { ReactNode } from "react";
import { BrandMark } from "~/components/brand-mark";

export function AuthLayout({
  title,
  description,
  back,
  footer,
  children,
}: {
  title: string;
  description: ReactNode;
  back?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div
      className="bg-background text-foreground flex min-h-svh flex-col px-5"
      style={{ paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="mx-auto flex w-full max-w-sm flex-1 flex-col pt-3 pb-6 md:justify-center md:pt-0">
        <div className="flex h-11 items-center">{back}</div>
        <main className="mt-3">
          <div className="flex justify-center">
            <BrandMark size={64} />
          </div>
          <h1 className="type-title mt-6 text-center">{title}</h1>
          <p className="text-muted-foreground type-body mt-2 text-center text-balance">{description}</p>
          <div className="mt-8">{children}</div>
        </main>
        {footer && <footer className="mt-auto flex justify-center pt-8 md:mt-4 md:pt-0">{footer}</footer>}
      </div>
    </div>
  );
}
